import { render } from "./UserModelDialog.vue?vue&type=template&id=5f98e9ea&scoped=true"
import script from "./UserModelDialog.vue?vue&type=script&lang=js"
export * from "./UserModelDialog.vue?vue&type=script&lang=js"

import "./UserModelDialog.vue?vue&type=style&index=0&id=5f98e9ea&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98e9ea"]])

export default __exports__